import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.PUDO },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }
    ],
    groupBy: ChartQueryParam.SENDER,
    groupByMode: ChartGroupByMode.VALUE
};
